/** App-wide configurations */

export default {
    GMAPS_API_KEY: 'AIzaSyA4HesefDq3o2vGMtG1tgdWwqnB0hkF9Eg',
};
